<div *ngIf="!isSmallDevice" class="row">
<div class="col-3 col-sm-3 col-md-3 col-lg-3" *ngFor="let dashboarditem of dashboardItems">

<mat-card class="example-card"
[ngStyle]="{ height: ( 250+(dashboarditem.hoechsteAnzahlProjektstufen*35) )+'px'}"
>
  <mat-card-header
    [ngClass]="findCorrectFontColor(dashboarditem.color)"
    [ngStyle]="{ 'background-color': dashboarditem.color, 'height': (dashboarditem.hoechsteAnzahlProjektstufen*35)+'px'}">
    <mat-card-title class="breakWords" *ngFor="let projektstufen of dashboarditem.obersteProjektstufe;">{{projektstufen}}</mat-card-title>
  </mat-card-header>

    <ng-container *ngIf="dashboarditem.status==1">
      <mat-card-content>
      <!-- *1000 um auf Milisekunden zu rechnen und dann -1 Stunde rechnen -->
      <h1 >{{(dashboarditem.start)/60/60 | roundDown}}:{{dashboarditem.start*1000 | date:'mm:ss'}}</h1>
        <button mat-stroked-button (click)="pauseTime(dashboarditem)">{{'pages.landingpage.favorit.pause' | translate}}</button>
      <button mat-stroked-button (click)="stopTime(dashboarditem)">{{'pages.landingpage.favorit.stop' | translate}}</button>
      </mat-card-content>
      <mat-card-actions>
      </mat-card-actions>
    </ng-container>

  <ng-container *ngIf="dashboarditem.status==2">
    <mat-card-content>
      <h1 >{{(dashboarditem.time) | roundDown}}:{{dashboarditem.time*3600*1000 | date:'mm:ss'}}</h1>
      <button mat-stroked-button (click)="continueTime(dashboarditem)">{{'pages.landingpage.favorit.continue' | translate}}</button>
    </mat-card-content>
    <mat-card-actions>
    </mat-card-actions>
  </ng-container>

    <ng-container *ngIf="dashboarditem.status==0;">
      <mat-card-content>
      <h1>{{'pages.landingpage.favorit.zeroTime' | translate}}</h1>
      <button mat-stroked-button (click)="startTime(dashboarditem)">{{'pages.landingpage.favorit.start' | translate}}</button>
      </mat-card-content>
      <mat-card-actions>
        <button mat-button (click)="addForm(dashboarditem.prjId)">{{'pages.landingpage.favorit.öffnen' | translate}}</button>
        <button mat-button class="deleteButton" (click)="delete(dashboarditem)">{{'pages.landingpage.favorit.delete' | translate}}</button>
      </mat-card-actions>
    </ng-container>



</mat-card>
</div>
</div>
<div *ngIf="isSmallDevice" class="row" >
  <div  class="col-6 col-sm-6 col-md-6 col-lg-6" *ngFor="let dashboarditem of dashboardItems">

    <mat-card class="example-card"
              [ngStyle]="{height: ( 250+(dashboarditem.hoechsteAnzahlProjektstufen*35) )+'px'}"
              >
      <mat-card-header
        [ngClass]="findCorrectFontColor(dashboarditem.color)"
        [ngStyle]="{ 'background-color': dashboarditem.color,  'height': (dashboarditem.hoechsteAnzahlProjektstufen*35)+'px'}">
        <mat-card-title class="breakWords" *ngFor="let projektstufen of dashboarditem.obersteProjektstufe;">{{projektstufen}}</mat-card-title>
      </mat-card-header>

      <ng-container *ngIf="dashboarditem.status==1; else stoppedTime">
        <mat-card-content>
          <!-- *1000 um auf Milisekunden zu rechnen und dann -1 Stunde rechnen -->
          <h1 >{{(dashboarditem.start)/60/60 | roundDown}}:{{dashboarditem.start*1000 | date:'mm:ss'}}</h1>
          <button mat-stroked-button (click)="stopTime(dashboarditem)">{{'pages.landingpage.favorit.stop' | translate}}</button>
        </mat-card-content>
      </ng-container>

      <ng-template #stoppedTime>
        <mat-card-content >
          <h1>{{'pages.landingpage.favorit.zeroTime' | translate}}</h1>
          <button mat-stroked-button (click)="startTime(dashboarditem)">{{'pages.landingpage.favorit.start' | translate}}</button>
        </mat-card-content>
        <mat-card-actions>
          <button mat-button class="openButton" (click)="addForm(dashboarditem.prjId)">{{'pages.landingpage.favorit.öffnen' | translate}}</button>
          <button mat-button class="deleteButton openButton" (click)="delete(dashboarditem)">{{'pages.landingpage.favorit.delete' | translate}}</button>
        </mat-card-actions>
      </ng-template>



    </mat-card>
  </div>
</div>
<button hidden="true" id="timerButton" mat-button (click)="timer()">Add Time</button>
